export const PaymentProcedureType = {
  AUTH: 'Auth',
  SALE: 'Sale',
}
